import React, { Component } from 'react'
import { connect } from "react-redux";
import moment from 'moment'

class History extends Component {


  render() {
    const history = this.props.history || [];
    return (
      <div className="history">
          {
            history.map((obj) =>
            (
              <div key={obj.id} className="history_wrapper">
                <p className="date">{moment(obj.created_at).format('MMMM DD, YYYY || hh:mm:ss A')}</p>
                <p className="last_worked">{obj.user ? "Last worked by " + obj.user.first_name : null} || <span>{obj.comments}</span> || <span>{obj.complaint_text && obj.complaint_text.comment}</span>
                {obj.complaint_text && obj.complaint_text.resolution_status && 
                <span> || Resolution Status: {obj.complaint_text.resolution_status} 
                {obj.complaint_text.upgradeProduct && <span> (upgraded with: {obj.complaint_text.upgradeProduct.product_name} {obj.complaint_text.upgradeProduct.color_name})</span>}
                {obj.complaint_text.replace_accessory && 
                <span> (replaced with: {obj.complaint_text.replace_accessory})</span>
                }
                </span>
                
                }
               
               
                </p>
              </div>
            )
             )
          }

        </div>

    )
  }
}

const mapStateToProps = state => ({
  complaintDetail: state.serviceCenter.complaintsDetail,
})
export default connect(mapStateToProps, null)(History);